import { FormulaSetStatus } from '@prisma/client';
import { createZodDto } from 'nestjs-zod';
import { z } from 'zod';

export const formulaSetVersionDto = z.object({
  id: z.number().int(),
  formulaSetId: z.string(),
  version: z.number().int(),
  createdAt: z.date(),
  updatedAt: z.date(),
  status: z.nativeEnum(FormulaSetStatus),
  script: z.string(),
});

export const formulaSetVersionNoScriptDto = formulaSetVersionDto.omit({
  script: true,
});

export class FormulaSetVersionDto extends createZodDto(formulaSetVersionDto) {}

export class FormulaSetVersionNoScriptDto extends createZodDto(
  formulaSetVersionNoScriptDto,
) {}
